import { Box, Grid } from '@mui/material';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import ImageModal from '../../Modals/ImageModal/ImageModal';
import ImageComponent from '../../ImageComponent';
import { BlockAnimationWithImageDescriptionData } from './BlockAnimationWithImageDescriptionData';
import EditableText from '../../Form/EditableText';
import CloseButton from '../../Buttons/Close';

const BlockAnimationWithImageDescription = (props: BlockProps) => {
  const {
    isEditing, isTemplate, data, editHandler,
  } = props;
  const blockData = data.data as BlockAnimationWithImageDescriptionData;
  const {
    title, imgLeft, imgRight, imgLeftDesc, imgRightDesc, text1, text2,
  } = blockData;

  const { id } = data;

  return (
    <Grid container flexDirection="column" gap={3}>
      <Grid item container flexDirection="row" justifyContent="space-evenly" rowGap={3}>
        {title && (
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            className="animation-block-slide-down mt-2"
            sx={{
              overflow: 'hidden',
              backgroundPosition: 'center 0px',
            }}
          >
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              className="block-content-wrapper"
              style={{
                margin: '0 !important',
              }}
            >
              <Grid item sx={Utils.hoverBorder(isEditing)}>
                <CloseButton
                  show={isEditing}
                  updateHandler={() => {
                    delete blockData.title;
                    editHandler(id, blockData);
                  }}
                />
                <EditableText
                  text={title.value}
                  textColor={title.settings?.textColor}
                  isEditable={isEditing && !isTemplate}
                  updateHandler={(text) => {
                    blockData.title.value = text;
                    editHandler(id, blockData);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item gap={3} flexDirection="column" maxWidth="40%">
          {imgLeft && (
            <Grid item className="animation-block-slide-from-left" sx={Utils.hoverBorder(isEditing)}>
              {isEditing && (
                <CloseButton updateHandler={() => {
                  delete blockData.imgLeft;
                  editHandler(id, blockData);
                }}
                />
              )}
              <ImageModal
                disabled={isTemplate || !isEditing}
                images={[]}
                handleOnConfirm={(url: string) => {
                  blockData.imgLeft.value = url;
                  editHandler(id, blockData);
                }}
              >
                <ImageComponent src={imgLeft.value} />
              </ImageModal>
            </Grid>
          )}
          {imgLeftDesc && (
            <Grid
              container
              item
              justifyContent="center"
              className="animation-block-slide-from-left mt-3"
            >
              <Box sx={Utils.hoverBorder(isEditing)} width="100%">
                {isEditing && (
                  <CloseButton updateHandler={() => {
                    delete blockData.imgLeftDesc;
                    editHandler(id, blockData);
                  }}
                  />
                )}
                <EditableText
                  text={imgLeftDesc.value}
                  textColor={imgLeftDesc.settings?.textColor}
                  isEditable={isEditing && !isTemplate}
                  updateHandler={(text) => {
                    blockData.imgLeftDesc.value = text;
                    editHandler(id, blockData);
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>

        <Grid item gap={3} flexDirection="column" maxWidth="40%">
          {imgRight && (
            <Grid item className="animation-block-slide-from-right" sx={Utils.hoverBorder(isEditing)}>
              {isEditing && (
                <CloseButton updateHandler={() => {
                  delete blockData.imgRight;
                  editHandler(id, blockData);
                }}
                />
              )}
              <ImageModal
                disabled={isTemplate || !isEditing}
                images={[]}
                handleOnConfirm={(url: string) => {
                  blockData.imgRight.value = url;
                  editHandler(id, blockData);
                }}
              >
                <ImageComponent src={imgRight.value} />
              </ImageModal>
            </Grid>
          )}
          {imgRightDesc && (
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              className="animation-block-slide-from-right mt-3"
            >
              <Box sx={Utils.hoverBorder(isEditing)} width="100%">
                {isEditing && (
                  <CloseButton updateHandler={() => {
                    delete blockData.imgRightDesc;
                    editHandler(id, blockData);
                  }}
                  />
                )}
                <EditableText
                  text={imgRightDesc.value}
                  textColor={imgRightDesc.settings?.textColor}
                  isEditable={isEditing && !isTemplate}
                  updateHandler={(text) => {
                    blockData.imgRightDesc.value = text;
                    editHandler(id, blockData);
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid className="animation-block-slide-up mt-2" item container flexDirection="column" gap={3}>
        {text1 && (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
          >
            <Box sx={Utils.hoverBorder(isEditing)} width="88%">
              {isEditing && (
                <CloseButton updateHandler={() => {
                  delete blockData.text1;
                  editHandler(id, blockData);
                }}
                />
              )}

              <EditableText
                text={text1.value}
                isEditable={isEditing && !isTemplate}
                updateHandler={() => {

                }}
              />
            </Box>
          </Grid>
        )}

        {text2 && (
          <Grid
            container
            item
            xs={12}
            flexDirection="row"
            justifyContent="center"
            className="animation-block-slide-up"
          >
            <Box sx={Utils.hoverBorder(isEditing)} width="88%">

              {isEditing && (
                <CloseButton updateHandler={() => {
                  delete blockData.text2;
                  editHandler(id, blockData);
                }}
                />
              )}

              <EditableText
                text={text2.value}
                isEditable={isEditing && !isTemplate}
                updateHandler={() => {

                }}
              />
            </Box>
          </Grid>
        )}

      </Grid>
    </Grid>
  );
};

export default BlockAnimationWithImageDescription;
